<template>
<div>
  <div class="footer">
    <div class="footer-top">
      <div>
        <p class="footer-title">关于鸟鸟配音</p>
        <ul class="footer-content">
          <li><router-link to="/">公司介绍</router-link></li>
          <li>|</li>
          <li><router-link to="/">使用帮助</router-link></li>
          <li>|</li>
          <li><router-link to="/">意见反馈</router-link></li>
          <li>|</li>
          <li><router-link to="/">免责声明</router-link></li>
        </ul>
      </div>
      <div>
        <p class="footer-title">友情链接</p>
        <ul class="footer-content">
          <li><a href="https://tao.huangque888.com" target="_blank">优惠淘</a></li>
          <li>|</li>
          <li><a href="https://blog.huangque888.com" target="_blank">Tech Blog</a></li>
          <li>|</li>
          <li><a href="https://www.huangque888.com" target="_blank">微群网</a></li>
          <li>|</li>
          <li><a href="https://tools.huangque888.com" target="_blank">DevTools</a></li>
        </ul>
      </div>
    </div>
    <div class="foot-img">
      <div class="foot-m">
        <img src="../assets/images/erweima-1.png" alt="么了个鱼">
        <span>小程序</span>
      </div>
      <div class="foot-m">
        <img src="../assets/images/erweima.png" alt="外卖优惠get君">
        <span>关注公众号</span>
      </div>
    </div>
  </div>
    <div class="footer-bottom">
      <span>Copyright©2018-2023 鸟鸟配音</span>
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow" class="miitbeian ml" ><span>京ICP备19053165号</span></a>      
    </div>

<div class="service">
    <div  class="type-style">
        <div  class="item-type">
            <i class="el-icon-mic"></i>
            <div><router-link to="/hecheng">去配音</router-link></div>
        </div> 
        <div class="line"></div>
        <div  class="item-type">
            <i class="el-icon-s-platform"></i>
            <el-popover
            placement="left"
            title=""
            width="200"
            trigger="hover" popper-class="serv"
            >
              
                <div  class="juan-z">
                  <img src="../assets/images/erweima-1.png" alt="微信扫一扫打开" >
                </div>
              <div slot="reference">小程序</div>
            </el-popover>
            
        </div>        
        <div class="line"></div>
        <div  class="item-type">
          <i class="el-icon-service"></i>
          <el-popover
            placement="left"
            title=""
            width="200"
            trigger="hover" popper-class="serv"
            >
            <el-collapse value="pp1" accordion>
              <el-collapse-item title="微信捐赠码" name="pp1">
                <div  class="juan-z">
                  <img src="../assets/images/wei-pay.png" alt="微信捐赠码" >
                </div>
              </el-collapse-item>
              <el-collapse-item title="支付宝捐赠码" name="pp2">
                <div  class="juan-z">
                  <img src="../assets/images/ali-pay.png" alt="支付宝捐赠码" >
                </div>
              </el-collapse-item>
            </el-collapse>
            
            <div slot="reference" >捐助</div>
          </el-popover>
          
        </div>
        
    </div>
</div>


</div>



</template>
<style>
.service {
    position: fixed;
    right: -29px;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.el-collapse{
  border:0!important;
}
.type-style {
    width: 65px;    
    background: #ffffff;
    box-shadow: 0px 0.2vw 0.33333vw 0px #ececec;
    border-radius: 0.53333vw;
}
.item-type:hover{
  transform:scale(1.08);
  cursor:pointer;
  transition:all .2s;
}
.item-type:hover i {
  color:#409EFF;
}
.item-type {
    text-align: center;    
    font-size: 12px;
    font-family: PingFang SC;    
    color: #231815;
    cursor: pointer;
    padding:10px 2px;
}
.juan-z {
  width:100%;
  margin:0 auto;
  text-align:center;
}
.juan-z img{
  width:180px;
  height:180px;
}
.serv{
  padding-top:0px!important;
  padding-bottom:0px!important;
}
</style>
<script>
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?0268ac3afd082f41e6487f848b61e861";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
</script>